import React = require("react");
import {PercentageCircle} from "../../../../components/charts/PercentageCircle";
import {FormatLocaleNumber} from "../../DashboardUtils";
import {amber, danfossRed, green, turquoise} from "../../../../styles/global/variables";

export enum Positions {
    MOBILE_LOCATION = "55fcec8c-c7bf-11e7-ad82-525400c5f801",
    OTHER = "55fce566-c7bf-11e7-ad82-525400c5f801",
    UNREGISTERED = "55fce912-c7bf-11e7-ad82-525400c5f801",
    POS = "55fa676e-c7bf-11e7-ad82-525400c5f801",
    OFFICE = "55fceaca-c7bf-11e7-ad82-525400c5f801",
    WAREHOUSE = "55fce2be-c7bf-11e7-ad82-525400c5f801",
    FACTORY = "55fce746-c7bf-11e7-ad82-525400c5f801"
}

export const REGISTERED_LOCATIONS_GUIDS = [
    Positions.MOBILE_LOCATION,
    Positions.OFFICE,
    Positions.OTHER,
    Positions.POS,
    Positions.FACTORY,
];

interface Props {
    title: string;
    value: number;
    total: number;
    reverseColors: boolean;
    noGreen: boolean;
    shortcutCode: string;
    stackManager?: any;
    onClick?: () => void;
    defaultColor?: string;
    anticlockwise?: boolean;
}

export class FilterCountCard extends React.Component<Props, any> {
    constructor(props: Props) {
        super(props);
        this.useAsFilter = this.useAsFilter.bind(this);
    }

    public render() {
        return (
            <div className={"filter-count-card"} onClick={this.useAsFilter}>
                <div className={"filter-count-card__header"}>
                    <div className={"filter-count-card__header-title"}>
                        <p>{this.props.title}</p>
                    </div>
                </div>
                <div className={"filter-count-card__content"}>
                    <div className={"filter-count-card__content--left"}>
                        <p>
                            <span className={"big-font"}>{FormatLocaleNumber(
                                this.props.value)}</span>/ {FormatLocaleNumber(this.props.total)}
                        </p>
                    </div>
                    {this.props.total != null && this.props.total > 0
                        && <div className={"filter-count-card__content--right"}>
                            <PercentageCircle
                                width={90}
                                height={90}
                                percentage={this.props.value / this.props.total * 100}
                                name={this.props.title}
                                percentageColor={this.props.defaultColor || this.getColor(
                                    this.props.value / this.props.total * 100)}
                                arcWidth={10}
                                anticlockwise={this.props.anticlockwise}
                            />
                        </div>
                    }
                </div>
            </div>
        );
    }

    private useAsFilter() {
        if (this.props.onClick) {
            this.props.onClick()
        }
        if (this.props.stackManager) {
            switch (this.props.shortcutCode) {
                case "GOTO_ACTIVE_LOCATIONS":
                    this.props.stackManager.addNewLevel("LocationListLevel", {filterActiveLocations: true});
                    return;
                case "GOTO_ACTIVE_EQUIPMENT":
                    this.props.stackManager.addNewLevel("EquipmentListLevel", {filterActiveEquipment: true});
                    return;
                case "GOTO_EQUIPMENT_OUT_OF_STOCK":
                    this.props.stackManager.addNewLevel("EquipmentListLevel", {filterEquipmentOutOfStock: true});
                    return;
                case "GOTO_EQUIPMENT_STOCK_LEVEL_ABOVE_75":
                    this.props.stackManager.addNewLevel("EquipmentListLevel", {
                        filterEquipmentStockLevel: {
                            comparator: ">",
                            percentageValue: 75,
                        },
                    });
                    return;
                case "GOTO_EQUIPMENT_ABOVE_TARGET":
                    this.props.stackManager.addNewLevel("EquipmentListLevel", {filterEquipmentAboveTarget: true});
                    return;
                case "GOTO_EQUIPMENT_BELOW_TARGET":
                    this.props.stackManager.addNewLevel("EquipmentListLevel", {filterEquipmentBelowTarget: true});
                    return;
            }
        }
    }

    private getColor(perc: number) {
        if (this.props.reverseColors) {
            if (perc >= 75) {
                return danfossRed;
            }
            if (perc >= 50) {
                return amber;
            }
            if (perc >= 25) {
                if (this.props.noGreen) {
                    return amber;
                }
                return turquoise;
            }
            if (this.props.noGreen) {
                return amber;
            }
            return green;
        }
        if (perc >= 75) {
            if (this.props.noGreen) {
                return amber;
            }
            return green;
        }
        if (perc >= 50) {
            if (this.props.noGreen) {
                return amber;
            }
            return turquoise;
        }
        if (perc >= 25) {
            return amber;
        }
        return danfossRed;
    }
}